<template>
  <div v-if="mt5Enabled" ref="campaignAlertPopup" class="campaign-alert-popup">
    <van-popup
      v-model="showPopup"
      :position="'center'"
      :overlay="true"
    >
      <div class="campaign-alert-popup-wrapper">
        <span class="alert-title">温馨提示</span>
        <div class="alert-content">
          <span class="campaign-name">{{ currentCampaign ? currentCampaign.name : '' }}</span> 正在进行
        </div>
        <div class="alert-bottom">
          <button v-if="pageType != 'app'" type="button" class="alert-button" @click="onCancel">
            取消
          </button>
          <button type="button" class="alert-button secondary" @click="onContinueWithdrawal">
            继续取款
          </button>
          <button type="button" class="alert-button primary" @click="goToCampaign">
            活动详情
          </button>
        </div>
      </div>
    </van-popup>
    <!-- 廣告頁插頁 -->
    <transition name="slide">
      <div v-if="showCampaignPage" class="campaign-page-container">
        <iframe :src="currentCampaign.linkUrl" class="campaign-page" loading="lazy"/>
        <button class="campaign-page-close-btn" @click="showCampaignPage = false">
          关闭
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/plugins/api'
import { isMT5Enabled, removeQueryParam } from '@/utils/helper'
import { mapState } from 'vuex'
import { umengRecord, EventCodes, getPredurationStr, getTimestampStr } from '@/utils/umeng'

export default {
  name: 'CampaignAlertPopup',
  computed: {
    ...mapState(['pageType', 'user'])
  },
  data() {
    return {
      showPopup: false,
      currentCampaign: null,
      adPosition: '7',
      channel: 'WITHDRAW',
      mt5Enabled: isMT5Enabled(),
      showCampaignPage: false,
      localStorageKey: 'lastShowedCAPDate',
      showPopupInitialTimestamp: -1,
      currentIp: ''
    }
  },
  watch: {
    currentCampaign: function(newVal) {
      this.currentCampaign = newVal
      this.showPopup = !!newVal
      if (this.showPopup) {
        this.showPopupInitialTimestamp = Date.now()
      }
    }
  },
  mounted() {
    this.localStorageKey = `${this.localStorageKey}_${this.user.loginname}`

    if (this.showedPopupToday()) {
      return
    }

    this.getCurrentIp()
    this.queryForApp()
  },
  methods: {
    showedPopupToday() {
      // Get the current date in YYYY-MM-DD format
      const today = new Date().toISOString().split('T')[0]

      if (localStorage.getItem(this.localStorageKey) !== today) {
        localStorage.setItem(this.localStorageKey, today)
        return false
      }

      return true
    },
    getCurrentIp() {
      api.getCurrentIp().then(res => {
        this.currentIp = res.data.ip
      })
    },
    queryForApp() {
      const data = {
        channel: this.channel
      }
      api.queryForAppH5(data).then(res => {
        if (res && res.data && res.data.code == 200 && res.data.ch_msg[this.adPosition]) {
          this.currentCampaign = res.data.ch_msg[this.adPosition].length > 0 ? res.data.ch_msg[this.adPosition][0] : null
        }
      })
    },
    onCancel() {
      this.$router.go(-1)
    },
    onContinueWithdrawal() {
      this.currentCampaign = null
    },
    goToCampaign() {
      umengRecord(EventCodes.Uc_Wd_Ad_Click, {
        uc_wd_ad_click_name: this.currentCampaign.name,
        uc_wd_ad_click_channel: this.channel,
        uc_wd_ad_click_preduration: getPredurationStr(this.showPopupInitialTimestamp),
        uc_wd_ad_click_link_url: this.currentCampaign.linkUrl,
        uc_wd_ad_click_url: window.location.href,
        uc_wd_ad_click_user_agent: window.navigator.userAgent,
        uc_wd_ad_click_screen_size: `${window.screen.width}x${window.screen.height}`,
        uc_wd_ad_click_timestamp: getTimestampStr(),
        uc_wd_ad_click_ip: this.currentIp
      })

      if (this.pageType == 'app') {
        this.showCampaignPage = true
        return
      }
      window.open(removeQueryParam(this.currentCampaign.linkUrl, 'noneheader'), '_blank')
    }
  }
}
</script>
<style>
.campaign-alert-popup .van-popup {
    width: 90%;
    border-radius: 10px;
    opacity: 1;
}

.campaign-alert-popup.fade-me-out {
    opacity: 0;
}

.campaign-alert-popup .campaign-alert-popup-wrapper {
    font-size: 0.4rem;
    min-height: 2.3rem;
    /* padding-top: 0.6rem; */
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    /* padding-bottom: 0.3rem; */
}

.campaign-alert-popup-wrapper .alert-title {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    font-size: 0.35rem;
    /* text-align: left; */
    font-weight: bold;
    /* padding-left: 0.3rem; */
    border-bottom: 0.01rem solid rgba(51, 51, 51, 0.4);
}

.campaign-alert-popup-wrapper .alert-content {
    /* flex: 1; */
    /* display: flex; */
    /* flex-direction: column; */
    /* justify-content: center; */
    /* align-items: center; */
    font-size: 0.3rem;
    min-height: 1.2rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    max-height: 380px;
    overflow-y: scroll;
}

.campaign-alert-popup-wrapper .alert-content .campaign-name {
  background-image: linear-gradient(45deg, #FFD700, #DAA520, #B8860B);
  background-clip: text;
  -webkit-background-clip: text; /* For Safari */
  color: transparent;
  font-weight: 800;
}

.campaign-alert-popup-wrapper .alert-bottom {
    border-top: 0.01rem solid rgba(51, 51, 51, 0.4);
    /* padding-top: 0.05rem; */
    /* padding-bottom: 0.05rem; */
    display: flex;
}

.campaign-alert-popup-wrapper .alert-button {
    border: none;
    background-color: transparent;
    font-size: 0.3rem;
    color: rgb(31, 158, 219);
    padding: 0.2rem 0.4rem;
    flex: 1;
    font-weight: 300;
}

.campaign-alert-popup-wrapper .alert-button.secondary {
    color: tomato;
    border-left: 0.01rem solid rgba(51, 51, 51, 0.4);
    border-right: 0.01rem solid rgba(51, 51, 51, 0.4)
}

.campaign-alert-popup-wrapper .alert-button.primary {
    background: linear-gradient(45deg, #FFD700, #DAA520, #B8860B);
    color: #fff;
    font-weight: 800;
}

.campaign-alert-popup-wrapper ul li {
    padding-left: 0.2rem;
    /* margin-top: 0.15rem; */
}

.campaign-alert-popup-wrapper ul.enable-list-type li {
    list-style: decimal;
}

.campaign-alert-popup-wrapper ul.enable-list-type.A li {
    list-style: upper-alpha;
}

.campaign-alert-popup-wrapper ul ul {
    margin-left: 0.4rem;
}

.campaign-alert-popup-wrapper .red {
    color: red;
}

.campaign-page-container {
    z-index: 999999;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    height: 97.5vh;
    width: 100%;
    top: 0;
  }

iframe.campaign-page {
  width: 95%;
  height: 100%;
  margin-left: 2.5%;
  margin-top: 2.5%;
}

button.campaign-page-close-btn {
  position: absolute;
  right: 0rem;
  top: 0.35rem;
  margin-right: 0.3rem;
  height: 0.75rem;
  width: 1.4rem;
  border-radius: 0.1rem;
  border: 0;
  font-size: 0.25rem;
  color: #ffff;
  background: #444;
  line-height: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateY(100%);
  /* opacity: 0; */
}
.slide-enter-to, .slide-leave {
  transform: translateY(0);
  /* opacity: 1; */
}
</style>
